define("shared/components/shared/media-items/modal-display", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <img alt={{@mediaItem.defaultCaption}} class="o--modal__media" src={{@mediaItem.largeDisplayUrl}} />
  
  {{! Change Background }}
  {{#if this.canChangeBackground}}
    <Shared::Ui::Button
      @additional="rounded"
      @class="h--modal__overlayBtn--bottomRight qa--change_background_btn"
      @onClick={{this.changeBackground}}
      @variant="outline"
      data-test-id="modal-display-change-background-button"
    >
      {{svg-jar "ai-sparkle" class="o--icon"}}
      {{t "editor.change_background.title"}}
    </Shared::Ui::Button>
  {{/if}}
  
  {{! Note: IF not yet approved by the owner of the original media, request to use image already sent }}
  {{#if @mediaItem.needsApproval}}
    <span class="o--mediaOverlay">
      <span class="img--overlay__pending"></span>
    </span>
  {{/if}}
  */
  {
    "id": "RGkhqM4Z",
    "block": "[[[10,\"img\"],[15,\"alt\",[30,1,[\"defaultCaption\"]]],[14,0,\"o--modal__media\"],[15,\"src\",[30,1,[\"largeDisplayUrl\"]]],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"canChangeBackground\"]],[[[1,\"  \"],[8,[39,1],[[24,\"data-test-id\",\"modal-display-change-background-button\"]],[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"rounded\",\"h--modal__overlayBtn--bottomRight qa--change_background_btn\",[30,0,[\"changeBackground\"]],\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,2],[\"ai-sparkle\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n    \"],[1,[28,[35,3],[\"editor.change_background.title\"],null]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,1,[\"needsApproval\"]],[[[1,\"  \"],[10,1],[14,0,\"o--mediaOverlay\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"img--overlay__pending\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@mediaItem\"],false,[\"if\",\"shared/ui/button\",\"svg-jar\",\"t\"]]",
    "moduleName": "shared/components/shared/media-items/modal-display.hbs",
    "isStrictMode": false
  });

  let ModalDisplayComponent = (_class = class ModalDisplayComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "cache", _descriptor2, this);

      _initializerDefineProperty(this, "router", _descriptor3, this);

      _initializerDefineProperty(this, "store", _descriptor4, this);
    }

    get canChangeBackground() {
      return Boolean(this.args.mediaItem && this.args.mediaItem.isImage && !this.args.mediaItem.collectSource && this.auth.currentAccount.rolloutAiInstantBackgrounds);
    }

    changeBackground() {
      const {
        name
      } = this.router.currentRoute;
      const contextPath = name.includes('calendar') ? 'cluster.schedule.calendar.media' : 'cluster.media.edit';
      const route = `${contextPath}.editor.modal.background`;
      const postMediaItem = this.store.createRecord('post-media-item', {
        mediaType: 'image',
        mediaItem: this.args.mediaItem
      }); // @ts-expect-error lib/editor/addon/routes/modal needs to be refactored before this type can change

      this.cache.add('editor-post-media-item', postMediaItem, {
        expiry: this.cache.expiry(5, 'minutes'),
        persist: false
      });
      this.router.transitionTo(route);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "changeBackground", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "changeBackground"), _class.prototype)), _class);
  _exports.default = ModalDisplayComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ModalDisplayComponent);
});